<template>
    <div id="app">
    </div>
</template>

<script>

export default{
    data: function() {
        return {
        }
    }, 

    methods: {
        getHotelId(){
            if(typeof this.$attrs.hotelSelected == 'undefined' || 
                this.$attrs.hotelSelected == null || 
                this.$attrs.hotelSelected == '' ||
                this.$attrs.hotelSelected == 0){
                this.$router.push('/marcar'); 
            }else{
                if(process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'quality'){
                    window.open('http://192.168.200.20:8181/?hotel='+this.$attrs.hotelSelected);
                    this.$router.push('/marcar'); 
                }else if(process.env.NODE_ENV == 'production'){
                    window.open('http://vgsc2.vilagale.pt/web-pos/login?hotel='+this.$attrs.hotelSelected);
                    this.$router.push('/marcar'); 
                }else{
                    this.notify('Erro de ENV', 'red');
                    this.$router.push('/marcar'); 
                }
            }
        },
    },
    created() {
        this.getHotelId();
    },
}

</script>
